"use strict";
'use es6';
/**
 *
 * @see https://www.tinymce.com/docs/configure/content-filtering/#valid_elements
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicSchema = void 0;
var basicSchema = ['#p[style]', '-strong/b', '-em/i', '-span[!style]', 'ol[style]', 'ul[style]', 'li[style]', 'a[href|target|style|rel]'].join(',');
exports.basicSchema = basicSchema;